/** Adds a variant to the real Shopify cart via the storefront AJAX API. */
export async function addVariantToCart(
  variantId: number,
  quantity: number,
): Promise<void> {
  const res = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
  });
  if (!res.ok) {
    throw new Error(`cart/add.js failed: ${res.status}`);
  }
}
